import { Stack, Typography } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";

export default function TitleWithSubtitle({
  title,
  subtitle,
  sx,
  titleLevel,
}: {
  title?: string;
  subtitle?: string;
  sx?: SxProps;
  titleLevel?: "h2" | "h3";
}) {
  return (
    <Stack spacing={titleLevel === "h2" ? "12px" : "8px"} sx={sx}>
      {title && (
        <Typography
          level={titleLevel || "h4"}
          sx={{ wordBreak: "keep-all", overflowWrap: "break-word" }}
        >
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography level={"body-md"} sx={{ opacity: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
